import BackboneElement from './BackboneElement';
import CodeableConcept from './types/CodeableConcept';
import ValueX from './types/ValueX';
import ObservationReferenceRange from './ObservationReferenceRange';

import merge from 'lodash/merge';

export default class ObservationComponent extends BackboneElement {
    static __className = 'ObservationComponent';

    __objectStructure = {
        code: CodeableConcept,
        value: ValueX,
        dataAbsentReason: CodeableConcept,
        interpretation: [CodeableConcept],
        referenceRange: [ObservationReferenceRange],
    };

    constructor(constructJson, className = 'ObservationComponent') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
